// @nx/enforce-module-boundaries: disable

import { IUserFullObject } from '@intigral/types';
import {
    isFreeOperator,
    isPaymentMethodSelected,
} from './payment';
import { SUBSCRIPTION_STATUS } from '@intigral/constant';
import {
    getBaseSubscription,
    getPlusTierGuid,
    isFreeTier,
    isLegacyTier,
    isSubscriptionRenewalSuccess,
    isTierSubscriptionSuccess,
    // isTierUnSubscribedAndActive,
} from './subscription';
import { getPathNameWithoutLangPrefix } from '../helpers';



/**
 * Utility function to show update payment banner when the payment is failed.
 * @param {IUserFullObject} user User object.
 * @returns {boolean} Return true in case of payment failure.
 */
export const showUpdatePayment = (user: IUserFullObject): boolean => {
    if (user.segment !== 'B2C') {
        return false;
    }
    const paymentMethodAdded = isPaymentMethodSelected(user);
    if (!paymentMethodAdded) {
        return false;
    }
    if (user.tierStatus?.statusName?.toUpperCase() == SUBSCRIPTION_STATUS.SUSPENDED) {
        return true;
    }
    const baseSubscription = getBaseSubscription(user);
    return baseSubscription?.statusName.toUpperCase() === SUBSCRIPTION_STATUS.SUSPENDED ? true : false;
};


/**
 * Utility function to check if the Support Chat (Zendesk or Genesys) window is open by default.
 * @param {IUserFullObject} pathname - The page route for which the Support Chat window should be shown.
 * @returns {boolean} Returns true if the Support Chat window should be shown, false otherwise.
 */

export const shouldDefaultOpenSupportChat = (pathname: string): boolean => {
    const allowedPath = ['contact-us'];
    if (allowedPath.includes(getPathNameWithoutLangPrefix(pathname))) {
        return true;
    }
    return false;
};

/**
 * Determines if the 'Mission Complete Renew Quest' UI should be shown for the Renew Quest.
 * @param {IUserFullObject} user - The user object
 * @returns {boolean} True if the quest should be shown, false otherwise
 */
export const isShowMissionCompleteRenewQuest = (user: IUserFullObject) => {
    const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    const isLegacyUser = isLegacyTier(tierGuid);
    if (tierGuid === getPlusTierGuid()?.toUpperCase() || isLegacyUser) {
        if (isSubscriptionRenewalSuccess(user)) {
            return true;
        }
        // else if (isTierUnSubscribedAndActive(user)) {
        //     return true;
        // }
    }
    return false;
};

/* Determines if the 'Mission Complete Renew Quest' UI should be shown for the Upgrade Quest.
 * @param { IUserFullObject } user - The user object
 * @returns { boolean } True if the quest should be shown, false otherwise
 */
export const isShowMissionCompleteUpgradeQuest = (user: IUserFullObject) => {
    const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    if (tierGuid === getPlusTierGuid()?.toUpperCase()) {
        if (isSubscriptionRenewalSuccess(user)) {
            return true;
        }
        // else if (isNoOpOperator(user?.operator) && isTierSubscriptionSuccess(user)) {
        //     return true;
        // }
        // else if (isTierSubscriptionSuccess(user)) {
        //     return true;
        // }
    }
    return false;
};

/**
 * Determines if the 'Just Upgrade Reward Card' UI should be shown for the user (upgrade from basic to premium not renew).
 * @param {IUserFullObject} user - The user object
 * @returns {boolean} True if the reward card should be shown, false otherwise
 */
export const isShowJustUpgradeRewardCard = (user: IUserFullObject) => {
    const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    const isLegacyUser = isLegacyTier(tierGuid);
    if (
        tierGuid &&
        (tierGuid === getPlusTierGuid()?.toUpperCase() || isLegacyUser) &&
        isTierSubscriptionSuccess(user)
    ) {
        return true;
    }
    return false;
};

/**
 * Determines if the upgrade popup for Quest should be shown to the user.
 * @param {IUserFullObject} user - The user object
 * @returns {boolean} True if the popup should be shown, false otherwise
 */
export const shouldOpenUpgradePopupForRewardCard = (user: IUserFullObject) => {
    const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    if (isFreeTier(user)) {
        return true;
    } else if (isLegacyTier(tierGuid)) {
        return true;
    }
    return false;
};

/**
 * Determines if the 'Upgrade Reward Quest' UI should be shown for the user.
 * @param {IUserFullObject} user - The user object
 * @returns {boolean} True if the upgrade reward quest should be shown, false otherwise
 */
export const showUpgradeRewardQuest = (user: IUserFullObject) => {
    const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    if (isFreeTier(user)) {
        return true;
    } else if (isLegacyTier(tierGuid)) {
        return true;
    } else if (isShowMissionCompleteUpgradeQuest(user)) {
        return true;
    }

    return false;
};

/**
 * Determines if the 'Renew Reward Quest' UI should be shown for the user.
 * @param {IUserFullObject} user - The user object
 * @returns {boolean} True if the renew reward quest should be shown, false otherwise
 */
export const showRenewRewardQuest = (user: IUserFullObject) => {
    // const tierGuid = (user?.tierStatus?.tierGuid || user?.tierConfig?.tierGuid || '')?.toUpperCase();
    if (!isFreeTier(user)) {
        return true;
    }
    return false;
};
